import cx from "clsx";
import ButtonTransparentV2 from "kreate-common/modules/kreate-ui/components/ButtonTransparentV2";
import InputV3 from "kreate-common/modules/kreate-ui/components/InputV3";
import React from "react";
import { MdAdd, MdRemove } from "react-icons/md";

import styles from "./index.module.scss";

import { useField$Natural } from "@/modules/form-field/hooks/useField$Natural";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  value: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  color?: "error" | "normal";
  disabled?: boolean;
  actions: {
    increase: (() => void) | undefined;
    decrease: (() => void) | undefined;
    setToMax: (() => void) | undefined;
  };
};

function Base({
  className,
  style,
  value,
  onChange,
  onBlur,
  color,
  disabled,
  actions,
}: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <InputV3
        size="lg"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        autoComplete="off"
        color={color}
        disabled={disabled}
        leftAdornment={
          <InputV3.Adornment>
            <ButtonTransparentV2
              content={<MdRemove size="24px" style={{ margin: "-5px" }} />}
              disabled={!actions.decrease || disabled}
              onClick={actions.decrease}
            />
          </InputV3.Adornment>
        }
        rightAdornment={
          <>
            <InputV3.Adornment>
              <ButtonTransparentV2
                content={<MdAdd size="24px" style={{ margin: "-5px" }} />}
                disabled={!actions.increase || disabled}
                onClick={actions.increase}
              />
            </InputV3.Adornment>
            <InputV3.Separator />
            <InputV3.Adornment>
              <ButtonTransparentV2
                content="MAX"
                disabled={!actions.setToMax || disabled}
                onClick={actions.setToMax}
              />
            </InputV3.Adornment>
          </>
        }
      />
    </div>
  );
}

// Syntactic sugar to integrate with `useField$Natural` easier
function UseField$Natural({
  api,
  ...otherProps
}: {
  api: ReturnType<typeof useField$Natural>;
} & Partial<Props>) {
  return (
    <Base
      value={api.draft}
      onChange={api.setDraft}
      onBlur={api.validateAfterEditing}
      color={api.error ? "error" : "normal"}
      actions={{
        increase: api.increase,
        decrease: api.decrease,
        setToMax: api.setToMax,
      }}
      {...otherProps}
    />
  );
}

const InputNumEditions$Compact = Object.assign(Base, { UseField$Natural });

// TODO: @kien-kreate: move this component to kreate-components
export default InputNumEditions$Compact;
